import { Button } from "@/components/ui/Button";
import { Sheet } from "@/components/shell/Sheet";
import { Entry } from "@/components/settings/ChangelogSheet";
import type { ChangelogEntry } from "@/lib/changelog";

type Props = {
  open: boolean;
  onClose: () => void;
  entries: ChangelogEntry[];
};

/**
 * Modal "Co nowego" — pokazuje wpisy changelog od ostatnio widzianej
 * wersji do aktualnej. Auto-trigger w AppShell po update aplikacji.
 *
 * Różnica od ChangelogSheet (klik w numer wersji w Settings):
 *   - ChangelogSheet = pełna historia wszystkich wersji
 *   - WhatsNewSheet  = tylko nowe od ostatniej wizyty, z CTA "Świetnie!"
 *     i kontekstem "co się zmieniło od kiedy mnie nie było"
 *
 * Layout reuse'uje `Entry` z ChangelogSheet — single source of truth
 * dla formatowania wpisu wersji.
 */
export function WhatsNewSheet({ open, onClose, entries }: Props) {
  if (entries.length === 0) return null;
  return (
    <Sheet open={open} onClose={onClose} title="✨ Co nowego w Sianko">
      <p className="-mt-1 mb-3 text-[12px] text-muted leading-relaxed">
        Aplikacja została zaktualizowana. Oto co się zmieniło od Twojej
        ostatniej wizyty:
      </p>

      <div className="space-y-5">
        {entries.map((entry, i) => (
          <Entry key={i} entry={entry} />
        ))}
      </div>

      <Button
        type="button"
        className="mt-5 w-full"
        variant="accent"
        onClick={onClose}
      >
        Świetnie!
      </Button>
    </Sheet>
  );
}
